import {Component, ElementRef, Input, OnChanges, OnInit, ViewChild} from '@angular/core';
import {ConfService} from '../conf.service';
import {JsonEditorComponent, JsonEditorOptions} from 'ang-jsoneditor';
import {ICategory} from '../crudapi/crudapi.component';
import {Observable} from 'rxjs';
import {FormControl} from '@angular/forms';
import {environment} from '../../environments/environment';
import {ActivatedRoute, Router} from '@angular/router';
import {KongService} from '../kong.service';
import {MatSnackBar} from '@angular/material';
import {AppComponent} from '../app.component';
import {NgxXml2jsonService} from 'ngx-xml2json';
import {HeadersComponent} from '../devex/headers/headers.component';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
import {ApigatewayListenerService} from '../apigateway-listener.service';

const incr = 5;
declare let $;
@Component({
  selector: 'app-executor',
  templateUrl: './executor.component.html',
  styleUrls: ['./executor.component.css']
})
export class ExecutorComponent implements OnInit, OnChanges {
  @Input() executors: any;

  save: boolean;
  workspace: any;
  application: any;
  items: any;
  attributes: any;
  attributeList = [];
  @Input() authModel = {
    'authAttributes': {}
  };
  @Input() headers = [];
  @Input() mockResponses = [];
  @Input() showResponseAttributes = false;
  @Input() queryParams = [];
  @Input() requestBody = {};
  @Input() prerequisites: any;
  @Input() parametersHeaders: any;
  @Input() paramModel: any;
  @Input() selectedDatabaseType = '';
  responseAttributes = [];
  executorMethods = [
    {name: 'GET'},
    {name: 'POST'},
    {name: 'PUT'},
    {name: 'DELETE'},
    {name: 'PATCH'}
  ];

  executorTypes = [
    {'displayName': 'Simple API', 'value': 'API'},
    {'displayName': 'Business Logic API', 'value': 'BUSINESSLOGIC'},
    {'displayName': 'Data Access API', 'value': 'DATAACCESS'},
    {'displayName': 'Query API', 'value': 'QUERY'},
    {'displayName': 'SQL Query API', 'value': 'SQLQUERY'},
    {'displayName': 'Third Party API', 'value': 'THIRDPARTY'},
  ];

  scope = [{'displayName': 'Public', 'value': 'public'},
    {'displayName': 'Private', 'value': 'private'}];
  @Input() scopeSelected = 'public';
  @Input() description: string;
  @Input() executorCategory: string;
  @Input() executor_name: string;
  @Input() buttonText: string;
  executor_type: string;
  @Input() selectedVersion: string;
  @Input() selectedExecutor: string;
  @Input() selectedExecutorType: string; // = 'BUSINESSLOGIC';
  @Input() executor_display_name: string;
  @Input() referrer: string;
  @Input() source: string;
  @Input() editFlag: boolean;
  @Input() orig_executor_name: any;
  @Input() orig_executor_version: any;
  @Input() gatewaySettings: any;
  @Input() gatewayControl = new FormControl([]);

  version: string;
  filteredOptions: Observable<ICategory[]>;
  myControl = new FormControl();
  destroy: any;
  Blocks =[];
  BlockList = {
    '1': 0,
    '2': 25,
    '3': 50,
    '4': 75,
    '5': 100
  };
  progress = 0;
  progressMessage: string;
  showNextPanel = false;
  entity: string;
  partner = localStorage.getItem('partner');
  partnerKey = localStorage.getItem('partnerKey');
  account_id = localStorage.getItem('account');
  apiKey = localStorage.getItem('apikey');
  url = environment.konghost;
  @Input() selectedIndex: any;
  executor: any;
  gatewayFullUrl: string;
  gatewayUrl: any;
  servicedata: any;
  routepathdata: any;
  ratelimitingOrig: any;
  keyauthOrig: any;

  toggleFlag = false;
  isAPIAlreadyPresent: boolean;
  isAPIAlreadyPresentCheckCompleted = false;
  previouslyCheckedName: any;
  previouslyCheckedVersion: any;

  @ViewChild('toolbox') toolbox: ElementRef;
  @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;
  options1 = new JsonEditorOptions();
  @ViewChild(HeadersComponent) devexHeader: HeadersComponent;
  isToggleExpanded = false;

  apiGateways: any;


  constructor(
      private _route: ActivatedRoute,
      private confPost: ConfService, private kongService: KongService,
      public snackBar: MatSnackBar,
      private appComp: AppComponent,
      public platform: LeftpanelComponent, private apiGatewayListenerInstance: ApigatewayListenerService, private router: Router,
      private ngxXml2jsonService: NgxXml2jsonService) {
  }
  ngOnChanges() {

  }

  getRequestBody() {
    return this.devexHeader.getRequestBody();
  }

  async ngOnInit() {
    // this.gatewayUrl = (this.partner === this.account ? 'gateway.' + this.partner + '.apiplatform.io' : 'gateway.' + this.partner + '.' + this.account + '.apiplatform.io');
    this.gatewayUrl = await this.platform.getDefaultGatewayURL();
    this.gatewayFullUrl = 'https://' + this.gatewayUrl;

    if (this.platform.apiGateways !== null && this.platform.apiGateways !== undefined) {
      this.apiGateways = this.platform.apiGateways;
    } else {
      await this.confPost.getPartnerSettings(localStorage.getItem('partner'), localStorage.getItem('account'), localStorage.getItem('partnerKey')).toPromise().then(data => {
            let resp: any;
            resp = data;
            this.apiGateways = resp['apigateway'];
            this.platform.apiGateways = resp['apigateway'];
          },
          error => {
            this.platform.handleErrorGracefully(error, 'Error while getting list of API Gateways. Please try again after sometime.');
          });
    }

    switch (this.referrer) {

      case 'QUERY':
      case 'SQLQUERY':
        this.executorTypes = [
          // {'displayName': 'Query API', 'value': 'QUERY'},
          {'displayName': 'SQL Query API', 'value': 'SQLQUERY'},
        ];
        break;
      case 'UNIFIEDQUERY':
        this.executorTypes = [
          {'displayName': 'Unified Query API', 'value': 'UNIFIEDQUERY'},
        ];
        break;
      case 'DATATRANSFORMATION':
        this.executorTypes = [
          {'displayName': 'Data Transformation API', 'value': 'DATATRANSFORMATION'},
        ];
        break;
      case 'PLSQL':
        this.executorTypes = [
          // {'displayName': 'Query API', 'value': 'QUERY'},
          {'displayName': 'PLSQL API', 'value': 'PLSQL'},
        ];
        break;
      case 'DATAACCESS':
        this.executorTypes = [
          {'displayName': 'Data Access API', 'value': 'DATAACCESS'}
        ];
        break;
      case 'BUSINESSLOGIC':
        this.executorTypes = [
          {'displayName': 'Business Logic API', 'value': 'BUSINESSLOGIC'}
        ];
        break;
      case 'THIRDPARTY':
        this.executorTypes = [
          {'displayName': 'Third Party API', 'value': 'THIRDPARTY'}
        ];
        break;
      case 'WORKFLOW':
        this.executorTypes = [
          {'displayName': 'Workflow API', 'value': 'WORKFLOW'}
        ];
        break;
      case 'API':
        this.executorTypes = [
          {'displayName': 'Simple API', 'value': 'API'}
        ];
        break;
      default:
        this.executorTypes = [
          {'displayName': 'Simple API', 'value': 'API'},
          {'displayName': 'Business Logic API', 'value': 'BUSINESSLOGIC'},
          {'displayName': 'Data Access API', 'value': 'DATAACCESS'},
          {'displayName': 'Query API', 'value': 'QUERY'},
          {'displayName': 'SQL Query API', 'value': 'SQLQUERY'},
          {'displayName': 'Third Party API', 'value': 'THIRDPARTY'},
          {'displayName': 'PLSQL API', 'value': 'PLSQL'}
        ];
    }

    if (this.referrer !== null && this.referrer !== undefined) {
      this.selectedExecutorType = this.referrer;
    }
    if (this.selectedExecutorType === null || this.selectedExecutorType === undefined)
      this.selectedExecutorType = 'BUSINESSLOGIC';
  }

  checkForExistingEntityAndExecutorFromFocusOut() {
    setTimeout(() => {
      this.checkForExistingEntityAndExecutor();
    }, 1000);
  }

  CheckForExistingEntityOrExecutor() {
    return new Promise((resolve, reject) => {
      Promise.resolve(this.platform.CheckForExistingEntityOrExecutor(this.executor_name, this.selectedVersion)).then(response => {
        this.isAPIAlreadyPresent = false;
        this.isAPIAlreadyPresentCheckCompleted = false;
        this.previouslyCheckedName = this.executor_name;
        this.previouslyCheckedVersion = this.version;
        resolve('success');
      }, error => {
        if (error && error.status) {
          if (error.status === 'already exists') {
            this.isAPIAlreadyPresent = true;
            this.isAPIAlreadyPresentCheckCompleted = false;
            this.previouslyCheckedName = this.executor_name;
            this.previouslyCheckedVersion = this.selectedVersion;
            resolve('failed');
            this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
              duration: 10000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
          } else if (error.status === 'failed') {
            this.isAPIAlreadyPresent = true;
            this.isAPIAlreadyPresentCheckCompleted = false;
            this.previouslyCheckedName = this.executor_name;
            this.previouslyCheckedVersion = this.selectedVersion;
            resolve('failed');
            this.platform.openSnackBar('Error occurred while checking your existing API information. Please try again after sometime.', 'Error', {
              duration: 10000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
          }
        }
      });
    });
  }

  checkForExistingEntityAndExecutor() {
    return new Promise(async (resolve, reject) => {
      if (this.executor_name !== null && this.executor_name !== undefined && this.executor_name !== '' && this.selectedVersion !== null && this.selectedVersion !== undefined && this.selectedVersion !== '') {
        if (this.isAPIAlreadyPresentCheckCompleted === false) {
          if (this.previouslyCheckedName !== undefined && this.previouslyCheckedName !== null && this.previouslyCheckedVersion !== undefined && this.previouslyCheckedVersion !== null) {
            if (this.editFlag === true) {
              if (this.executor_name !== this.orig_executor_name || this.selectedVersion !== this.orig_executor_version) {
                if (this.previouslyCheckedName !== this.executor_name || this.previouslyCheckedVersion !== this.selectedVersion) {
                  this.isAPIAlreadyPresentCheckCompleted = true;
                  await this.CheckForExistingEntityOrExecutor();
                  resolve('success');
                } else {
                  resolve('success');
                }
              } else {
                resolve('success');
              }
            } else {
              if (this.previouslyCheckedName !== this.executor_name || this.previouslyCheckedVersion !== this.selectedVersion) {
                this.isAPIAlreadyPresentCheckCompleted = true;
                await this.CheckForExistingEntityOrExecutor();
                resolve('success');
              } else {
                resolve('success');
              }
            }
          } else {
            this.isAPIAlreadyPresentCheckCompleted = true;
            await this.CheckForExistingEntityOrExecutor();
            resolve('success');
          }
        } else {
          resolve('success');
        }
      }
    });
  }

  displayFn(user?: ICategory): string | undefined {
    return user ? user.name : undefined;
  }

  toggleExecutor1(ev) {
    if (ev === 'DELETE') {
      if (this.isToggleExpanded === true) {
        this.isToggleExpanded = false;
        $('.executor-definition').slideToggle();
        $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
      }
    } else {
      if (this.isToggleExpanded === false) {
        this.isToggleExpanded = true;
        $('.executor-definition').slideToggle();
        $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
      }
    }
  }

  toggleExecutor(ev) {

    $('.executor-definition').slideToggle();
    $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
    this.isToggleExpanded = !this.isToggleExpanded;
  }
  setInterval(blockEnd, nextPanel) {
    this.destroy = setInterval(() => this.manageProgress(blockEnd, nextPanel), 1000);
  }
  manageProgress(target, showPanel) {
    if (this.progress >= target) {
      this.showNextPanel = showPanel;
      this.ngOnDestroy();
    } else {
      this.progress = this.progress + incr;
    }
    if (this.progress <= 35) {
      this.progressMessage = 'Setting Up Business Logic API';
    } else if (this.progress > 35 && this.progress <= 70) {
      this.progressMessage = 'Setting Up Database';
      /*} else if (this.progress > 70 && this.progress <= 98) {
          this.progressMessage = 'Creating dedicated File storage for your account';*/
    } else if (this.progress > 70) {
      this.progressMessage = 'Deploying into Cloud';
    }
  }
  ngOnDestroy() {
    clearInterval(this.destroy);
  }
  configureApiGateway() {
    this.routepathdata = {
      'name': this.partner + '-' + this.account_id + '-' + this.executor_name + '-' + 'path',
      'protocols': ['http', 'https'],
      'hosts': [this.gatewayUrl],
      'paths': ['/' + this.selectedVersion + '/' + this.executor_name]
    };
    this.ratelimitingOrig = {
      'name': 'rate-limiting',
      'config': {'minute': 5},
      'protocols': ['http', 'https'],
      'enabled': true
    };

    this.keyauthOrig = {
      'name': 'key-auth'
    };

    this.servicedata = {
      'name': this.partner + '-' + this.account_id + '-' + this.executor_name,
      'retries': 5,
      'protocol': 'https',
      'host': environment.apihostname,
      'port': 443,
      'path':  '/' + this.partner + '/' + this.account_id + '/' + this.selectedVersion + '/' + this.executor_name,
      'connect_timeout': 60000,
      'write_timeout': 60000,
      'read_timeout': 60000
    };
    this.kongService.createServiceToApiGateway(this.servicedata).subscribe(res => {
      Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'apigateway_services_create_success', 'INFO', 200, 'OK', '', this.servicedata, res, this.router.url)).then(resp => {
        const payloadToSend = {
          actions: resp
        };
        this.apiGatewayListenerInstance.apiGatewayListener.emit({
          type: 'audit',
          id: localStorage.getItem('IdOfSession'),
          payload: payloadToSend
        });
      });
      this.kongService.createRouteForAServiceToApiGateway(this.partner + '-' + this.account_id + '-' + this.executor_name + '-' + this.selectedVersion, this.routepathdata).subscribe(route => {
        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'apigateway_routes_create_success', 'INFO', 200, 'OK', '', {service: this.partner + '-' + this.account_id + '-' + this.executor_name + '-' + this.selectedVersion, payload: this.routepathdata}, route, this.router.url)).then(async resp => {
          const payloadToSend = {
            actions: resp
          };
          this.apiGatewayListenerInstance.apiGatewayListener.emit({
            type: 'audit',
            id: localStorage.getItem('IdOfSession'),
            payload: payloadToSend
          });
        });
        this.kongService.createPluginForServiceInApiGateway(this.partner + '-' + this.account_id + '-' + this.executor_name, this.ratelimitingOrig).subscribe(ratelimitingplugin => {
          this.kongService.createPluginForServiceInApiGateway(this.partner + '-' + this.account_id + '-' + this.executor_name, this.keyauthOrig).subscribe(keyauthplugin => {
            this.kongService.createPluginForRouteInApiGateway(this.partner + '-' + this.account_id + '-' + this.executor_name + '-path', this.ratelimitingOrig).subscribe(ratelimiting1 => {
              this.kongService.createPluginForRouteInApiGateway(this.partner + '-' + this.account_id + '-' + this.executor_name + '-path', this.keyauthOrig).subscribe(keyauth1 => {
              });
            });
          });
        });
      }, error => {
      });
    }, error => {
    });
  }
  copyMessage(event) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = $(event.target).text();
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }
}
